<template>
  <div class="trash-bin">
    <h2>ถังขยะ</h2>
    
    <div class="tabs">
      <button 
        class="tab-btn active"
      >
        การชำระเงินชั่วคราว
      </button>
    </div>

    <div v-if="loading" class="loading">
      กำลังโหลด...
    </div>

    <div v-else-if="rejectedItems.length === 0" class="no-data">
      ไม่มีรายการในถังขยะ
    </div>

    <div v-else class="items-list">
      <div v-for="item in rejectedItems" :key="item.id" class="item-card">
        <div class="item-header">
          <h3>รหัสจอง: {{ item.bookingCode }}</h3>
          <span class="rejected-date">ปฏิเสธเมื่อ: {{ formatDate(item.rejectedAt) }}</span>
        </div>
        
        <div class="item-details">
          <p><strong>จำนวนเงิน:</strong> {{ item.amount }} บาท</p>
          <p><strong>ปฏิเสธโดย:</strong> {{ item.rejectedBy }}</p>
          
        </div>

        <div class="item-actions">
          <button @click="viewPaymentSlip(item)" class="btn view-btn">
            ดูสลิป
          </button>
          <button @click="permanentDelete(item)" class="btn delete-btn">
            ลบถาวร
          </button>
        </div>
      </div>
    </div>

    <!-- Modal สำหรับดูสลิป -->
    <div v-if="selectedSlip" class="modal-overlay" @click="selectedSlip = null">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>สลิปการชำระเงิน</h3>
          <button class="close-btn" @click="selectedSlip = null">&times;</button>
        </div>
        <div class="modal-body">
          <img :src="selectedSlip" alt="Payment Slip" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { collection, query, where, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';
import { getStorage, ref as storageRef, deleteObject } from 'firebase/storage';

export default {
  name: 'TrashBin',
  setup() {
    const loading = ref(true);
    const rejectedItems = ref([]);
    const selectedSlip = ref(null);

    const fetchRejectedItems = async () => {
      loading.value = true;
      try {
        const collectionRef = collection(db, 'temp_payments');
        const q = query(collectionRef, where('status', '==', 'rejected'));
        const querySnapshot = await getDocs(q);
        
        rejectedItems.value = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
      } catch (error) {
        console.error('Error fetching rejected items:', error);
      } finally {
        loading.value = false;
      }
    };

    const viewPaymentSlip = (item) => {
      if ( item.slipUrl) {
        selectedSlip.value = item.slipUrl;
      } else if (item.paymentReceipt) {
        selectedSlip.value = item.paymentReceipt;
      } else if (item.fileInfo && item.fileInfo.url) {
        selectedSlip.value = item.fileInfo.url;
      } else {
        alert('ไม่พบสลิปการชำระเงิน');
      }
    };

    const permanentDelete = async (item) => {
      if (!confirm('คุณต้องการลบรายการนี้ออกจากถังขยะใช่หรือไม่? การดำเนินการนี้ไม่สามารถย้อนกลับได้')) {
        return;
      }

      try {
        const storage = getStorage();
        
        // ลบไฟล์สลิป
        if (item.fileInfo && item.fileInfo.storagePath) {
          try {
            const fileRef = storageRef(storage, item.fileInfo.storagePath);
            await deleteObject(fileRef);
            console.log('Deleted payment slip file');
          } catch (error) {
            console.log('File not found or already deleted');
          }
        }

        // ใช้ bookingCode ถ้ามี มิฉะนั้นใช้ id
        let documentId = item.bookingCode || item.id;

        // ลบข้อมูลจาก Firestore
        await deleteDoc(doc(db, 'temp_payments', documentId));
        
        // รีเฟรชข้อมูล
        await fetchRejectedItems();
      } catch (error) {
        console.error('Error permanently deleting item:', error);
        alert('เกิดข้อผิดพลาดในการลบรายการ: ' + error.message);
      }
    };

    const formatDate = (timestamp) => {
      if (!timestamp) return '';
      const date = timestamp.toDate();
      return date.toLocaleString('th-TH', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    };

    onMounted(() => {
      fetchRejectedItems();
    });

    return {
      loading,
      rejectedItems,
      selectedSlip,
      viewPaymentSlip,
      permanentDelete,
      formatDate
    };
  }
};
</script>

<style scoped>
.trash-bin {
  padding: 20px;
}

.tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.tab-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  background: #f0f0f0;
  cursor: pointer;
  transition: all 0.3s ease;
}

.tab-btn.active {
  background: #007bff;
  color: white;
}

.loading, .no-data {
  text-align: center;
  padding: 20px;
  color: #666;
}

.items-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.item-card {
  background: white;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.item-header h3 {
  margin: 0;
  color: #333;
}

.rejected-date {
  color: #666;
  font-size: 0.9em;
}

.item-details {
  margin-bottom: 15px;
}

.item-details p {
  margin: 5px 0;
}

.item-actions {
  display: flex;
  gap: 10px;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.view-btn {
  background: #4CAF50;
  color: white;
}

.delete-btn {
  background: #f44336;
  color: white;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  padding: 20px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.modal-header h3 {
  margin: 0;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
}

.modal-body img {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
}
</style>